import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'

import { wizard, meta } from 'helpers/decorators'
import { Title, Button, FormDebug } from 'components/misc'
import { Contact } from 'components/forms'
import { apiCodeLists, apiParticipants, apiConfiguration } from 'helpers/decorators/api'
import validate from './contacts.validation'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { connect } from 'react-redux'
import { initializeFormFields } from '../../../../helpers/formInitializationHelper'


const asyncValidate = (val, dispatch, props) => {
  const { values } = props
  const error = {
    text: "Sorry we already have an account with this email registered. If you want to start new level, <a href='/'>log to your account</a> and select option Start new Level.",
    intlKey: 'errors.sorry_we_already_have_this_email'
  }

  if (!get(values, 'email') && !get(values, 'secondaryEmail')) {
    return Promise.resolve()
  }

  const promises = []

  if (get(values, 'secondaryEmail')) {
    promises.push(props.checkEmail({ email: get(values, 'secondaryEmail') }))
  } else {
    promises.push(Promise.resolve())
  }

  if (get(values, 'email')) {
    promises.push(props.checkEmail({ email: get(values, 'email') }))
  } else {
    promises.push(Promise.resolve())
  }

  return Promise.all(promises).then(([secondaryEmail, email]) => {
    if (get(email, 'value') === true) {
      // eslint-disable-next-line
      throw { email: error }
    }

    if (get(secondaryEmail, 'value') === true) {
      // eslint-disable-next-line
      throw { secondaryEmail: error }
    }
  })
}

const enhance = compose(
  apiCodeLists(['phoneTypes'], {
    public: true
  }),
  apiParticipants(),
  apiConfiguration(),
  wizard({
    form: 'participantRegistration',
    multipage: true,
    destroyOnUnmount: false,
    validate,
    asyncValidate,
    asyncBlurFields: ['email', 'secondaryEmail']
  }),
  meta({
    title: 'Register participant',
    intlKey: 'pageTitle.register_participant'
  }),
  connect(
    ({ api }) => ({
      registrationInfo: get(api, 'participants.registrationInfo')
    }), {}
  )
)

class Contacts extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    codeLists: PropTypes.object,
    values: PropTypes.object,
    change: PropTypes.func.isRequired,
    getConfigurationKeyValue: PropTypes.func.isRequired,
    isConfigurationTrue: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    registrationInfo: PropTypes.object
  }

  componentDidMount = async() => {
    const registrationInfo = get(this.props, 'registrationInfo')

    if (registrationInfo) {
      const fieldsToInit = [
        { name: 'email', value: get(registrationInfo, 'email', null) },
        { name: 'emailAgain', value: get(registrationInfo, 'email', null) },
        { name: 'secondaryEmail', value: get(registrationInfo, 'secondaryEmail', null) },
        { name: 'secondaryEmailAgain', value: get(registrationInfo, 'secondaryEmail', null) },
        { name: 'tertiaryEmail', value: get(registrationInfo, 'tertiaryEmail', null) },
        { name: 'phoneNumber', value: get(registrationInfo, 'phoneNumber', null) },
        { name: 'phoneType.value', value: get(registrationInfo, 'phoneType.value', null) },
        { name: 'secondaryPhoneNumber', value: get(registrationInfo, 'secondaryPhoneNumber', null) },
        { name: 'secondaryPhoneType.value', value: get(registrationInfo, 'secondaryPhoneType.value', null) },
      ]

      initializeFormFields(this.props, fieldsToInit)
    }
  }

  render() {
    const { handleSubmit, codeLists, onSubmit, values } = this.props
    const selectedCountryIcoCode = get(
      values,
      'helpers.selectedCountry.isoCode'
    )

    const showSecondaryEmail = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationEmailAddress2.id)

    const showPhoneNumber = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationPhoneNumber.id)

    const showPhoneType = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationPhoneType.id)

    const showSecondaryPhone = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationSecondaryPhone.id)

    const showSecondaryPhoneType = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationSecPhoneType.id)

    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        data-testId="registrationContactsForm"
      >
        <Title h1>
          <FormattedMessage
            id="moduleTitle.contact_details"
            defaultMessage="Contact Details"
          />
        </Title>
        <Contact
          showSecondaryFields
          showSecondaryEmail={showSecondaryEmail}
          showPhoneNumber={showPhoneNumber}
          showPhoneType={showPhoneType}
          showSecondaryPhone={showSecondaryPhone}
          showSecondaryPhoneType={showSecondaryPhoneType}
          phoneTypes={codeLists.phoneTypes.list}
          selectedCountryIcoCode={selectedCountryIcoCode}
        />
        <FormDebug {...this.props} />
        <Button>
          <FormattedMessage id="button.continue" defaultMessage="Continue" />
        </Button>
      </form>
    )
  }
}

export default enhance(Contacts)
